"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixBigBrackets = fixBigBrackets;
function fixBigBrackets(tex) {
    return tex
        .replace(new RegExp(`\\\\Big\\s*⟨`, "g"), "\\Big<")
        .replace(new RegExp(`\\\\Big\\s*⟩`, "g"), "\\Big>");
}
